var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0498,
    y: 1.17871,
    width: 65.5,
    height: 65.5,
    rx: 32.75,
    fill: "#2867B2",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.0498,
    y: 1.17871,
    width: 65.5,
    height: 65.5,
    rx: 32.75,
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6316_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3999 18.5283H18.3999V50.5283H50.3999V18.5283Z",
    fill: "#2867B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9217 24.5283H25.8781C25.0624 24.5283 24.3999 25.171 24.3999 25.9606V43.096C24.3999 43.8882 25.0624 44.5283 25.8781 44.5283H42.9217C43.7374 44.5283 44.3999 43.8856 44.3999 43.096V25.9606C44.3999 25.1684 43.7374 24.5283 42.9217 24.5283ZM30.463 41.2728H27.4433V32.2408H30.463V41.2728ZM28.9532 31.0079H28.9347C27.9211 31.0079 27.2665 30.3153 27.2665 29.447C27.2665 28.5787 27.9422 27.8861 28.9743 27.8861C30.0063 27.8861 30.6425 28.5603 30.6636 29.447C30.6636 30.3127 30.009 31.0079 28.9558 31.0079H28.9532ZM41.3565 41.2728H38.3368V36.4407C38.3368 35.2261 37.8986 34.3972 36.8059 34.3972C35.9718 34.3972 35.4755 34.9559 35.2564 35.4963C35.1773 35.6904 35.1561 35.958 35.1561 36.2282V41.2728H32.1365C32.1365 41.2728 32.1761 33.0881 32.1365 32.2408H35.1561V33.521C35.5574 32.9045 36.2753 32.0309 37.8775 32.0309C39.8651 32.0309 41.3565 33.3216 41.3565 36.097V41.2754V41.2728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6316_2943"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.3999,
    y: 18.5283,
    width: 32,
    height: 32,
    rx: 8.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInShare);
export default __webpack_public_path__ + "static/media/linkedIn_share.5c9e05c08d58da981fc0ef9b24ce5e1b.svg";
export { ForwardRef as ReactComponent };